import classNames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import React, { memo } from 'react';

import { isChinaRealm } from '~/helpers/realm';
import useImageLoaded from '~/hooks/useImageLoaded';

import styles from './PageHeadImage.module.scss';

const isCN = isChinaRealm();

type IProps = {
  image: string;
  imageCN?: string;
  isVisible?: boolean;
  className?: string;
  opacity?: number;
  width?: number;
  height?: number;
};

const PageHeadImage: React.FC<IProps> = ({ isVisible = true, image, imageCN, className, opacity, width, height }) => {
  const src = isCN ? imageCN || image : image;
  const isImageLoaded = useImageLoaded(src);

  return (
    <AnimatePresence>
      {isVisible && isImageLoaded && (
        <motion.img
          className={classNames(styles.image, className)}
          src={src}
          width={width || 'auto'}
          height={height || 'auto'}
          initial={{ opacity: 0 }}
          animate={{ opacity: opacity || 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          style={{ minWidth: width || 'unset' }}
        />
      )}
    </AnimatePresence>
  );
};

export default memo(PageHeadImage);
